/* eslint-disable @typescript-eslint/no-explicit-any */

import {
	historyLoadingTextLabelInit,
	transactionHistoryEmptyState,
	transactionHistoryFilterEmptyState,
	transactionHistoryFilterForm
} from 'app/configs/transactionHistory.config';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import './TransactionHistoryPage.scss';
import FilterBarComponent from 'app/components/FilterBarComponent/FilterBarComponent';
import EmptyState from 'app/components/EmptyState/EmptyState';
import TableItem from 'app/components/TableItem/TableItem';
import { ITableItem } from 'app/interfaces/table-item/table-item.interface';
import { IPagination } from 'app/redux/reducers/PortofolioReducer';
import { RootState } from 'app/redux/store';
import { getTransactionHistoryListAction } from 'app/redux/actions/TransactionHistoryAction';
import { TransactionHistoryListItem } from 'app/redux/reducers/TransactionHistoryReducer';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import datePipe from 'app/utils/DatePipe';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import Pagination from 'app/components/Pagination/Pagination';
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import moment from 'moment';

export const tableItemsState: ITableItem[] = [
    {
        id: 'shimmering1',
        textLabel: historyLoadingTextLabelInit,
        subTextLabel: []
    },
    {
        id: 'shimmering2',
        textLabel: historyLoadingTextLabelInit,
        subTextLabel: []
    },
    {
        id: 'shimmering3',
        textLabel: historyLoadingTextLabelInit,
        subTextLabel: []
    }
];
export const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1
};

export const historyDataState = {
	tableItems: tableItemsState
};

const transactionHistory: TransactionHistoryListItem[] = [];

const TransactionHistoryPage = function init(): React.ReactElement {
    const dispatch = useDispatch();
    const transactionHistoryState = useSelector(
        (state: RootState) => state.transactionHistoryReducer
    );
    const [transactionList, setTransactionList] = useState(transactionHistory);
    const [transactionTextLabel, setTransactionTextLabel] = useState(historyDataState.tableItems);
    const [page, setPage] = useState(1);
    const [localPagination, setPagination] = useState(paginationInit);
    const { transactionHistoryList, loading, pagination } = transactionHistoryState;

	const fundingState = useSelector((state: RootState) => state.fundingReducer);
	const { transactionHistoryNumber, transactionHistoryBase64 } = fundingState;

    function getQueryParam(paramsName: string): string {
		const windowUrl = window.location.search;
		const params = new URLSearchParams(windowUrl);
		return params.get(paramsName) || '';
	}

    function filterOnSubmit(payload: Record<string, string | number>):void {
        const request = {
			type: String(payload.type) || '',
            status: String(payload.status) || '',
            startDate: String(payload.startDate) || '',
            endDate: String(payload.endDate) || '',
			limit: 10,
			page: 1
		};
        setPage(1);
        dispatch(getTransactionHistoryListAction(request));
    }

    function renderEmptyState(): React.ReactElement {
        const windowUrl = window.location.search;
        const emptyState: IEmptyState = windowUrl
                            ? transactionHistoryFilterEmptyState
                            : transactionHistoryEmptyState;
        return (
            <EmptyState
                image={emptyState.image}
                placeholder={emptyState.placeholder}
                caption={emptyState.caption}
            />
        );
    }

    useEffect(() => {
        const payload = {
            type: getQueryParam('type') || '',
            status: getQueryParam('status') || '',
            startDate: getQueryParam('startDate') || '',
            endDate: getQueryParam('endDate') || '',
			limit: 10,
			page: Number(getQueryParam('page')) || 1
		};
        dispatch(getTransactionHistoryListAction(payload));
    }, [page]);

    useEffect(() => {
		setPage(Number(getQueryParam('page')) || 1);
		if (transactionHistoryList) {
			setTransactionList(transactionHistoryList);
			setPagination(pagination);
		}
	}, [transactionHistoryList]);

    useEffect(() => {
        if (!loading) {
            const tableData: TransactionHistoryListItem[] = [];
            transactionList.forEach((each: TransactionHistoryListItem) => {
                const textLabel: ITextLabel[] = [
                    {
                        title: 'Jenis Transaksi',
						value: each.typeName,
						bg: false,
                        color: ''
                    },
                    {
                        title: 'Tanggal Transaksi',
						value: datePipe(each.createdDate),
						bg: false,
                        color: ''
                    },
					{
                        title: 'Kode Funding',
						value: each.transactionNumber ? each.transactionNumber : '-',
						bg: false,
                        color: ''
                    },
                    {
                        title: 'No. Pinjaman',
						value: each.loanNumber,
						bg: false,
                        color: ''
                    },
                    {
                        title: 'Nilai Transaksi',
						value: rupiahCurrencyFormatter(each.amount),
						bg: false,
                        color: '#0033A1'
                    },
                ];
                const tableItems: TransactionHistoryListItem = {
                    ...each,
                    showToggleButton: false,
                    textLabel,
                    transactionStatusName: each.status,
                    id: `Item${String(each.id)}`,
                    subTextLabel: []
                };
                tableData.push(tableItems);
            });
            setTransactionTextLabel(tableData);
        }
    }, [transactionList]);

	useEffect(() => {
		if (transactionHistoryBase64) {
			const url = window.URL.createObjectURL(transactionHistoryBase64);
			const anchor = document.createElement("a");
			anchor.href = url;
			anchor.download = `Funding - ${transactionHistoryNumber} - ${moment(new Date()).format("DDMMYY hhmmss")}.csv`;
			document.body.appendChild(anchor);
			anchor.click();
			window.URL.revokeObjectURL(url);
			document.body.removeChild(anchor);
		}
	}, [transactionHistoryBase64]);

    return (
        <div>
            <FilterBarComponent
                formField={transactionHistoryFilterForm}
                loading={loading}
                onSubmit={(payload: Record<string, string | number>) => filterOnSubmit(payload)}
            />
            <div className="transactionHistoryTable">
                {transactionTextLabel && transactionTextLabel.map((each: ITableItem, index) => (
                    <TableItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        tableData={each}
						loading={loading}
                        dropdownOnClick={null}
                        detailReachBottom={null}
						additionalButton
                    />
                ))}
            </div>
            { !loading && transactionHistoryList.length === 0 && (
                renderEmptyState()
            )}
            { localPagination.totalPage > 1
				&& <Pagination page={page} setPage={setPage} totalPage={localPagination.totalPage} />}
        </div>
    );
};

export default TransactionHistoryPage;
